import { $authHost, $host } from "./index";

export const fetchCsrfToken = async () => {
  const response = await $host.get('/api/csrf-token');
  return response.data.csrfToken;
};

export const registration = async (email, password, name, consentPersonalData, consentMarketing) => {
  const response = await $host.post('/api/user/registration', {
    email, password, name, consent_personal_data: consentPersonalData, consent_marketing: consentMarketing
  });
  return response.data;
};

export const login = async (email, password) => {
  const response = await $host.post('/api/user/login', { email, password });
  return response.data;
};

export const resendVerification = async (email) => {
    try {
        const response = await $host.post('/api/user/resend-verification', { email });
        return response.data;
    } catch (error) {
        console.error('Ошибка при повторной отправке верификации:', error);
        throw error;
    }
};

export const verifyEmail = async (token) => {
    try {
        const response = await $host.get(`/api/user/verify-email?token=${encodeURIComponent(token)}`);
        return response.data;
    } catch (error) {
        console.error('Ошибка при верификации email:', error);
        throw error;
    }
};

export const check = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
        return null;
    }
    try {
        const { data } = await $authHost.get('/api/user/auth');
        if (data.token) {
            localStorage.setItem('token', data.token);
        }
        return data.user;
    } catch (e) {
        localStorage.removeItem('token');
        throw e;
    }
};

export const updateProfile = async (userData) => {
  const csrfToken = await fetchCsrfToken();
  const response = await $authHost.put('/api/user/profile', { ...userData, _csrf: csrfToken });
  return response.data;
};

export const getUserProfile = async () => {
  const response = await $authHost.get('/api/user/profile');
  return response.data;
};

export const changePassword = async (oldPassword, newPassword) => {
  const csrfToken = await fetchCsrfToken();
  const response = await $authHost.put('/api/user/change-password', {
    oldPassword,
    newPassword,
    _csrf: csrfToken
  });
  return response.data;
};

export const forgotPassword = async (email) => {
  const response = await $host.post('/api/user/forgot-password', { email });
  return response.data;
};

export const resetPassword = async (token, newPassword) => {
  const response = await $host.post('/api/user/reset-password', {
    token,
    newPassword
  });
  return response.data;
};